import React from "react";
import { Play } from "lucide-react";
import { API } from "../lib/api";

export default function VideoCard({ video, onClick, fallbackThumb }) {
    const thumb = video.thumbnail_path
        ? `${API}/videos/${video.id}/thumbnail`
        : fallbackThumb;
    return (
        <button
            onClick={() => onClick(video)}
            className="group text-left card-ecom flex flex-col overflow-hidden"
            data-testid={`video-card-${video.id}`}
        >
            <div className="relative aspect-[4/5] bg-slate-100 overflow-hidden">
                {thumb ? (
                    <img
                        src={thumb}
                        alt={video.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                ) : (
                    <div className="w-full h-full bg-gradient-to-br from-slate-100 to-slate-200" />
                )}
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/15 transition-colors flex items-center justify-center">
                    <div className="w-12 h-12 rounded-full bg-white shadow-lg flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                        <Play className="w-5 h-5 text-coral" fill="#FF5A5F" />
                    </div>
                </div>
                {video.category && (
                    <div className="absolute top-3 left-3 chip chip-lime backdrop-blur">
                        {video.category}
                    </div>
                )}
            </div>
            <div className="p-4 flex-1 flex flex-col gap-1">
                <h3 className="font-display text-base font-semibold text-slate-900 leading-tight line-clamp-2">
                    {video.title}
                </h3>
                <div className="text-xs text-slate-500 mt-auto pt-2 flex items-center justify-between">
                    <span className="truncate">by {video.creator_name}</span>
                    <span className="chip chip-neutral">{video.views || 0} views</span>
                </div>
            </div>
        </button>
    );
}
